/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import React from "react";
import { Loading, useLogin } from "react-admin";

const LoginPage = () => {
  const login = useLogin();
  login();

  return <Loading />;
};

export default LoginPage;
